import React, { useState } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const DeletePopup = ({
    data = {},
    type = "website",
    closePopup,
    updateError,
    updateWebsite,
    updateSubscription,
    deleteBackup,
    restoreBackup,
    deleteTicket,
    deleteDomain,
    updateEmails
}) => {
    const {websiteId, subscription, backupData, ticketId, email} = data;
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        try {
            if (type === "website") {
                const res = await apiInstance.post(`/dashboard/website/pause/${websiteId}`);
                res.data.website && updateWebsite && updateWebsite(res.data.website);
                closePopup();
                setLoading(false)
            } 
            else if (type === "subscription") {
                const res = await apiInstance.post(`/dashboard/website/pause/${subscription?.site}`);
                res.data.website && updateSubscription && updateSubscription(res.data.website?.subscription);
                closePopup();
                setLoading(false)
            } 
            else if(type === "backupDelete"){
                const res = await apiInstance.post(
                    `/dashboard/backups/delete`,
                    {
                        siteData: {
                            websiteId: backupData.websiteId,
                            fileName: backupData.fileName
                        }
                    }
                );
                res.data.success && deleteBackup && deleteBackup(backupData.fileName);
                closePopup();
                setLoading(false)
            }
            else if(type === "backupRestore"){
                const res = await apiInstance.post(
                    `/dashboard/backups/restore`,
                    {
                        siteData: {
                            websiteId: backupData.websiteId,
                            fileName: backupData.fileName
                        }
                    }
                );
                res.data.success && restoreBackup && restoreBackup(backupData.fileName);
                closePopup();
                setLoading(false)
            }
            else if (type === "ticket") {
                const res = await apiInstance.delete(`/dashboard/support-ticket/${ticketId}`);
                res.data.ticket && deleteTicket && deleteTicket(ticketId);
                closePopup();
                setLoading(false)
            } 
            else if (type === "domainDelete"){
                await deleteDomain();
                closePopup();
                setLoading(false)
            }
            else if (type === "emailDelete"){

                const res = await apiInstance.post(
                    `/dashboard/emails/delete`,
                    {
                        websiteId: websiteId,
                        email: email
                    }
                );

                console.log(res.data);

                const emails = res.data.emails.emails;
                const emailsLimit = res.data.emails.allowedCount;

                emails && updateEmails && updateEmails(emails, emailsLimit);

                // await updateEmails(emails);

                closePopup();
                setLoading(false)
            }
        } catch (error) {
            console.error(`Error:`, error);
            updateError &&
                updateError(error.response?.data?.message || "Something went wrong");
            setLoading(false);
        }
    };

    return (
        <div className="mjs-pp">
            {
                type === 'backupDelete' ? (
                <>
                    <h2>Delete Backup</h2>
                    <p>
                        Are you sure you want to delete this backup?
                    </p>
                </>
                )
                : type === 'backupRestore' ? (
                <>
                    <h2>Restore Backup</h2>
                    <p>
                        Are you sure you want to restore this backup?
                    </p>
                </>
                )
                : type === 'ticket' ? (
                <>
                    <h2>Delete Support Ticket</h2>
                    <p>
                        Are you sure you want to delete this support ticket?
                    </p>
                </>
                )
                : type === 'domainDelete' ? (
                <>
                    <h2>Delete Domain</h2>
                    <p>
                        Are you sure you want to delete this domain?
                    </p>
                </>
                )
                : type === 'emailDelete' ? (
                <>
                    <h2>Delete Email</h2>
                    <p>
                        Are you sure you want to delete this email account? It will permanently remove all existing emails in this account.
                    </p>
                </>
                )
                :
                (
                <>
                    <h2>Delete Website</h2>
                    <p>
                        Are you sure you want to delete the website and cancel the subscription?
                    </p>
                </>
                )
            }

            <div className="mjs-bottom-row">
                {
                    type === 'backupRestore' ? (
                        <Button name="Restore" eventHandler={handleDelete} />
                    )
                    :
                    (
                        <Button name="Delete" eventHandler={handleDelete} />
                    )
                }
                {loading && (
                    <i
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                )}
            </div>
        </div>
    );
};

export default DeletePopup;
